module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-dolni_4_after_tn.jpg
// module id = 1619
// module chunks = 0